import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Header } from './components/Header';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { PasswordResetPage } from './pages/PasswordResetPage';
import { DashboardPage } from './pages/DashboardPage';
import { StoryEditorPage } from './pages/StoryEditorPage';
import { CollaborativeStoryEditorPage } from './pages/CollaborativeStoryEditorPage';
import { QuestionPage } from './pages/QuestionPage';
import { StoryWizardPage } from './pages/StoryWizardPage';
import { UserProfilePage } from './pages/UserProfilePage';
import { InvitePage } from './pages/InvitePage';
import DemoLandingPage from './pages/DemoLandingPage';
import DemoRecordingPage from './pages/DemoRecordingPage';
import { PurchasePage } from './pages/PurchasePage';
import { UpgradePage } from './pages/UpgradePage';
import { UpgradeSuccessPage } from './pages/UpgradeSuccessPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Header />
          <main className="container mx-auto lg:px-4 lg:py-8 md:px-2 md:py-6 px-0 py-4">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/reset-password" element={<PasswordResetPage />} />
              <Route path="/invite/:invitationId" element={<InvitePage />} />
              <Route path="/demo" element={<DemoLandingPage />} />
              <Route path="/demo/record" element={<DemoRecordingPage />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/story/new"
                element={
                  <ProtectedRoute>
                    <StoryWizardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/story/:storyId"
                element={
                  <ProtectedRoute>
                    <StoryEditorPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/story/:storyId/question/:questionId"
                element={
                  <ProtectedRoute>
                    <QuestionPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/collaborative-story/:storyId"
                element={
                  <ProtectedRoute>
                    <CollaborativeStoryEditorPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <UserProfilePage />
                  </ProtectedRoute>
                }
              />
              <Route path="/purchase" element={<PurchasePage />} />
              <Route
                path="/upgrade"
                element={
                  <ProtectedRoute>
                    <UpgradePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/upgrade-success"
                element={
                  <ProtectedRoute>
                    <UpgradeSuccessPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
